import React from "react";
import ElizabethHeader from "./ElizabethHeader";
import ElizabethSections from "./ElizabethSections";

const Elizabeth = () => {
  return (
    <div data-new-gr-c-s-check-loaded="14.1231.0" data-gr-ext-installed>
      <ElizabethHeader />
      <ElizabethSections />
    </div>
  );
};

export default Elizabeth;
